import RichText from '../../../components/RichText/RichText'

import { getCssVar } from '../../../utils/css'

export default function CardsList (props = {
    heading: null,
    richText: null,
    text: null,
    items: null
}) {
    const items = Array.isArray(props.items)
        ? props.items
            .filter(obj => obj.heading
                && obj.text)
            .map(obj => {
                const symbol = obj.icon
                    ? document.querySelector(`#icon-${obj.icon}`)
                    : null

                if (symbol) {
                    const dimensions = symbol.getAttribute('viewBox')
                        .replace(/0\s/g, '')
                        .split(' ')

                    obj.svg = {
                        className: `icon-${obj.icon}`,
                        width: dimensions[0],
                        height: dimensions[1]
                    }
                }

                return obj
            })
        : []

    if (!items.length)
        return null

    return (
        <section className="cards-list pad-section">
            <div className="container">
                {(props.heading || props.text)
                    && (
                        <div className="row flex-justify-content-center margin-5-b pad-3-b-lg-up">
                            <div className="col-12 col-8-md col-6-lg-up">
                                <div className="text-align-center">
                                    {props.heading
                                        && (
                                            <h2 className="text-underscore-condensed-center">
                                                {props.heading}
                                            </h2>)}
                                    {props.richText
                                        && (
                                            <RichText
                                                className="body-2"
                                                html={props.richText}
                                                style={{
                                                    color: getCssVar('--oxford')
                                                }}
                                            />)}
                                </div>
                            </div>
                        </div>)}
                <ul className="row flex-justify-content-center margin-3-b-neg">
                    {items
                        .map((obj, idx) => (
                            <li
                                key={`cards-list-${idx}`}
                                className="col-12 col-4-lg-up display-flex margin-3-b"
                            >
                                <div className="card flex-grow pad-3-l pad-3-r">
                                    <div className="row flex-nowrap pad-b">
                                        <h3 className="heading-4 col">
                                            {obj.heading}
                                        </h3>
                                        {obj.svg
                                            ? (
                                                <div className="col-auto pad-1-r">
                                                    <div className="icon">
                                                        <svg
                                                            className={obj.svg.className}
                                                            width={obj.svg.width}
                                                            height={obj.svg.height}
                                                            style={{ maxHeight: '38px' }}
                                                        >
                                                            <use xlinkHref={`#${obj.svg.className}`} />
                                                        </svg>
                                                    </div>
                                                </div>)
                                            : null}
                                    </div>
                                    <p
                                        className="body-3 text-overscore-condensed"
                                        style={{ color: '#0f3450' }}
                                    >
                                        {obj.text}
                                    </p>
                                </div>
                            </li>
                        ))}
                </ul>
            </div>
        </section>

    )
}
